<template>
    <router-view></router-view>
</template>

<script>
	export default {
		name: "Audience",
		props: ['monitor_uuid'],
	}
</script>

<style scoped>

</style>
